export default {"src":"/_next/static/media/firefox.46176f35.svg","height":82,"width":87,"blurWidth":0,"blurHeight":0};